import { useEffect, useState } from 'react';
import CONFIG from '@/config/global';
import { getBrowserSize, shouldRenderForMobile } from '@/helpers/layout';
import useInitialRender from '@/hooks/browser/useInitialRender';
import useWindowSize from '@/hooks/browser/useWindowSize';

const useShouldRenderForMobile = () => {
  const { isFirstRender } = useInitialRender();

  const [shouldRender, setShouldRender] = useState(shouldRenderForMobile({ isFirstRender }));
  
  const { width } = useWindowSize({ debounceTime: CONFIG.layoutShiftDebounceMs });
  const browserSize = getBrowserSize(width);

  useEffect(() => {
    setShouldRender(shouldRenderForMobile());
  }, [browserSize]);

  return shouldRender;
};

export default useShouldRenderForMobile;